<template>
    <app-page-options-list :options="options" />
</template>
<script>
    import PageOptionsList from '../UI/Controls/PageOptions/PageOptionsList.vue';

    export default {
        name: 'ContractorOptions',
        components: {
            appPageOptionsList: PageOptionsList
        },
        data() {
            return {
                options: [
                    { to: 'contractorDocumentsPage', label: 'Gestión de Documentos', icon: 'fa fa-folder-open' }
                ]
            };
        }
    };
</script>
